
const fromJson = (item) => {

    return {
        id : item.id,
        linhVuc : item.linhVuc,
        donVi  : item.donVi ,
        mucDo : item.mucDo,
        serviceCode  : item.serviceCode,
        nguCanh  : item.nguCanh,
        thuTuc : item.thuTuc
    }
}

const baseJson = () => {
    return {
        id: null,
        linhVuc : null,
        donVi  : null ,
        mucDo : null,
        serviceCode  : null,
        nguCanh  : null,
        thuTuc : null
    }
}

export const nguCanhModel = {
   fromJson, baseJson
}
